import gql from 'graphql-tag'
import { ILinkProps, Link } from 'office-ui-fabric-react/lib/Link'
import * as React from 'react'
import { LinkType } from '../../model'
import {
  DownloadBlobLinkMutationVariables,
  useDownloadBlobLinkMutation,
} from './DownloadLink.generated'

export type DownloadLinkProps = DownloadBlobLinkMutationVariables

export const DownloadLink: React.FC<DownloadLinkProps & ILinkProps> = ({
  uri,
  linkType = LinkType.Personal,
  expiresIn = 60,
  ...props
}) => {
  const [getLink] = useDownloadBlobLinkMutation({
    onCompleted: (data) =>
      uri.includes('.pdf')
        ? window.open(data.downloadBlobLink, '_blank')
        : (window.location.href = data.downloadBlobLink),
    fetchPolicy: 'no-cache',
  })
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault()
    getLink({
      variables: { uri, linkType, expiresIn },
    })
  }
  return uri ? <Link onClick={handleClick} {...props} /> : null
}

// tslint:disable-next-line
gql`
  mutation DownloadBlobLink(
    $uri: String!
    $linkType: LinkType
    $expiresIn: Int
  ) {
    downloadBlobLink(uri: $uri, linkType: $linkType, expiresIn: $expiresIn)
  }
`
